import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { removeUersFromContractChangeGql } from '../AgreementsQueries';

export const useRemoveAgreementsUer = ({
    contractChangeId,
    checkedIds,
    refreshAgreementData,
    refreshFilters,
}: {
    contractChangeId: number;
    checkedIds: number[];
    refreshAgreementData: () => void;
    refreshFilters: () => void;
}) => {
    const dispatch = useDispatch();

    const [
        removeUersFromContractChangeData,
        removeUersFromContractChangeStatus,
        removeUersFromContractChangeErr,
        removeUersFromContractChangeRequest,
        removeUersContractChangeSetData,
    ] = useRequest({
        requestId: 'removeUersFromContractChange',
        query: removeUersFromContractChangeGql,
        withEffect: false,
    });

    useEffect(() => {
        if (
            removeUersFromContractChangeStatus === RequestStatus.SUCCESS &&
            removeUersFromContractChangeData?.uerRemoveUersFromContractChange?.result
        ) {
            refreshAgreementData();
            refreshFilters();
        }
    }, [
        refreshAgreementData,
        refreshFilters,
        removeUersFromContractChangeData?.uerRemoveUersFromContractChange?.result,
        removeUersFromContractChangeStatus,
    ]);

    const removeUersHandler = useCallback(() => {
        dispatch(removeUersFromContractChangeRequest({ contractChangeId, uerIds: checkedIds }));
    }, [checkedIds, contractChangeId, dispatch, removeUersFromContractChangeRequest]);

    return {
        removeUerContractChangeData: removeUersFromContractChangeData?.uerRemoveUersFromContractChange,
        removeUersFromContractChangeStatus,
        removeUersFromContractChangeErr,
        removeUersContractChangeSetData,
        removeUersHandler,
    };
};
